import { render, staticRenderFns } from "./InventoryReceipts.vue?vue&type=template&id=ec16529e"
import script from "./InventoryReceipts.vue?vue&type=script&lang=js"
export * from "./InventoryReceipts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports